import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { STATUS_LABELS, translations } from "@/i18n/translations";
import api, { setLocale } from "@/lib/api";

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem("op_lang");
    if (saved) return saved;
    const detected = (navigator.language || "en").toLowerCase().startsWith("it") ? "it" : "en";
    // Persistiamo subito: l'interceptor delle API legge da localStorage.
    localStorage.setItem("op_lang", detected);
    return detected;
  });
  setLocale(lang);

  const setLang = useCallback((next) => {
    localStorage.setItem("op_lang", next);
    setLocale(next);
    setLangState(next);
    // Il backend usa questa lingua per notifiche e solleciti automatici.
    if (localStorage.getItem("op_token")) {
      api.put("/auth/lang", { lang: next }).catch(() => {});
    }
  }, []);

  const value = useMemo(
    () => ({
      lang,
      setLang,
      t: (key) => translations[lang][key] ?? translations.it[key] ?? key,
      ts: (value) => STATUS_LABELS[lang]?.[value] || value,
    }),
    [lang, setLang]
  );

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
